export default [
  // Home
  {
    name: '今日のモチベーション選択',
    path: '/stamp',
    component: () => import('@/views/stamp/Stamp'),
  },
]
